/**
 * @generated SignedSource<<9411122ef5790412a8bd7b1f50c766ba>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type AccountStatus = "active" | "closed" | "inactive" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type UserProfileCardRelay_query$data = {
  readonly activity?: {
    readonly workedOn: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly object: {
            readonly data: {
              readonly __typename: "AssetsObject";
              readonly links: {
                readonly web: string | null;
              } | null;
            } | {
              readonly __typename: "AssetsObjectType";
              readonly links: {
                readonly web: string | null;
              } | null;
            } | {
              readonly __typename: "AssetsSchema";
              readonly links: {
                readonly web: string | null;
              } | null;
            } | {
              readonly __typename: "BitbucketPullRequest";
              readonly href: AGG$URL | null;
            } | {
              readonly __typename: "CompassComponent";
              readonly url: string | null;
            } | {
              readonly __typename: "ConfluenceBlogPost";
              readonly links: {
                readonly base: string | null;
                readonly webUi: string | null;
              } | null;
            } | {
              readonly __typename: "ConfluenceDatabase";
              readonly links: {
                readonly base: string | null;
                readonly webUi: string | null;
              } | null;
            } | {
              readonly __typename: "ConfluenceEmbed";
              readonly links: {
                readonly base: string | null;
                readonly webUi: string | null;
              } | null;
            } | {
              readonly __typename: "ConfluenceFooterComment";
              readonly container: {
                readonly __typename: "ConfluenceBlogPost";
                readonly links: {
                  readonly base: string | null;
                  readonly webUi: string | null;
                } | null;
              } | {
                readonly __typename: "ConfluencePage";
                readonly links: {
                  readonly base: string | null;
                  readonly webUi: string | null;
                } | null;
              } | {
                readonly __typename: "ConfluenceWhiteboard";
                readonly links: {
                  readonly base: string | null;
                  readonly webUi: string | null;
                } | null;
              } | {
                // This will never be '%other', but we need some
                // value in case none of the concrete values match.
                readonly __typename: "%other";
              } | null;
              readonly links: {
                readonly base: string | null;
                readonly webUi: string | null;
              } | null;
            } | {
              readonly __typename: "ConfluenceInlineComment";
              readonly container: {
                readonly __typename: "ConfluenceBlogPost";
                readonly links: {
                  readonly base: string | null;
                  readonly webUi: string | null;
                } | null;
              } | {
                readonly __typename: "ConfluencePage";
                readonly links: {
                  readonly base: string | null;
                  readonly webUi: string | null;
                } | null;
              } | {
                readonly __typename: "ConfluenceWhiteboard";
                readonly links: {
                  readonly base: string | null;
                  readonly webUi: string | null;
                } | null;
              } | {
                // This will never be '%other', but we need some
                // value in case none of the concrete values match.
                readonly __typename: "%other";
              } | null;
              readonly links: {
                readonly base: string | null;
                readonly webUi: string | null;
              } | null;
            } | {
              readonly __typename: "ConfluencePage";
              readonly links: {
                readonly base: string | null;
                readonly webUi: string | null;
              } | null;
            } | {
              readonly __typename: "ConfluenceWhiteboard";
              readonly links: {
                readonly base: string | null;
                readonly webUi: string | null;
              } | null;
            } | {
              readonly __typename: "DevOpsDesign";
              readonly webUrl: AGG$URL | null;
            } | {
              readonly __typename: "DevOpsDocument";
              readonly webUrl: AGG$URL | null;
            } | {
              readonly __typename: "DevOpsPullRequestDetails";
              readonly url: string | null;
            } | {
              readonly __typename: "ExternalDocument";
              readonly url: string | null;
            } | {
              readonly __typename: "ExternalPullRequest";
              readonly url: string | null;
            } | {
              readonly __typename: "ExternalRemoteLink";
              readonly url: string | null;
            } | {
              readonly __typename: "JiraIssue";
              readonly webUrl: AGG$URL | null;
            } | {
              readonly __typename: "JiraPlatformComment";
              readonly issue: {
                readonly webUrl: AGG$URL | null;
              } | null;
              readonly webUrl: AGG$URL | null;
            } | {
              readonly __typename: "JiraServiceManagementComment";
              readonly issue: {
                readonly webUrl: AGG$URL | null;
              } | null;
              readonly webUrl: AGG$URL | null;
            } | {
              readonly __typename: "LoomVideo";
              readonly loomUrl: string;
            } | {
              readonly __typename: "MercuryFocusArea";
              readonly url: string | null;
            } | {
              readonly __typename: "MercuryPortfolio";
              readonly url: string | null;
            } | {
              readonly __typename: "RadarPosition";
              readonly url: string | null;
            } | {
              readonly __typename: "RadarView";
              readonly url: string | null;
            } | {
              readonly __typename: "TownsquareComment";
              readonly url: string | null;
            } | {
              readonly __typename: "TownsquareGoal";
              readonly url: string | null;
            } | {
              readonly __typename: "TownsquareProject";
              readonly url: string | null;
            } | {
              readonly __typename: "TrelloBoard";
              readonly trelloUrl: AGG$URL | null;
            } | {
              readonly __typename: "TrelloCard";
              readonly trelloUrl: AGG$URL | null;
            } | {
              // This will never be '%other', but we need some
              // value in case none of the concrete values match.
              readonly __typename: "%other";
            } | null;
          };
        };
      }>;
    };
  } | null;
  readonly knowledgeDiscovery?: {
    readonly reportingLines?: {
      readonly __typename: "KnowledgeDiscoveryReportingLines";
      readonly managers: ReadonlyArray<{
        readonly accountIdentifier: string | null;
        readonly numberOfDirectReports: number | null;
        readonly numberOfTotalReports: number | null;
        readonly pii: {
          readonly extendedProfile: {
            readonly jobTitle: string | null;
          } | null;
          readonly name: string | null;
          readonly picture: string | null;
        } | null;
      }>;
      readonly reports: ReadonlyArray<{
        readonly accountIdentifier: string | null;
        readonly numberOfDirectReports: number | null;
        readonly numberOfTotalReports: number | null;
        readonly pii: {
          readonly extendedProfile: {
            readonly jobTitle: string | null;
          } | null;
          readonly name: string | null;
          readonly picture: string | null;
        } | null;
      }>;
      readonly user: {
        readonly accountIdentifier: string | null;
        readonly numberOfDirectReports: number | null;
        readonly numberOfTotalReports: number | null;
        readonly pii: {
          readonly extendedProfile: {
            readonly jobTitle: string | null;
          } | null;
          readonly name: string | null;
          readonly picture: string | null;
        } | null;
      } | null;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null;
    readonly singleUser: {
      readonly __typename: "KnowledgeDiscoverySingleUser";
      readonly user: {
        readonly manager: {
          readonly id: string | null;
          readonly jobTitle: string | null;
          readonly name: string | null;
          readonly picture: string | null;
        } | null;
        readonly thirdPartyIntegrations: ReadonlyArray<{
          readonly externalId: string;
          readonly integrationId: string;
          readonly product: string;
        }> | null;
      } | null;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null;
  } | null;
  readonly user: {
    readonly __typename: string;
    readonly accountId: string;
    readonly accountStatus: AccountStatus;
    readonly appType?: string | null;
    readonly email?: string | null;
    readonly extendedProfile?: {
      readonly department: string | null;
      readonly jobTitle: string | null;
      readonly location: string | null;
      readonly organization: string | null;
    } | null;
    readonly name: string;
    readonly picture: AGG$URL;
  } | null;
  readonly " $fragmentType": "UserProfileCardRelay_query";
};
export type UserProfileCardRelay_query$key = {
  readonly " $data"?: UserProfileCardRelay_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserProfileCardRelay_query">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v1 = {
  "kind": "ScalarField",
  "name": "name"
},
v2 = {
  "kind": "ScalarField",
  "name": "picture"
},
v3 = {
  "kind": "ScalarField",
  "name": "email"
},
v4 = {
  "kind": "ScalarField",
  "name": "jobTitle"
},
v5 = [
  {
    "kind": "ScalarField",
    "name": "base"
  },
  {
    "kind": "ScalarField",
    "name": "webUi"
  }
],
v6 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "ConfluencePageLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v5/*: any*/)
    }
  ],
  "type": "ConfluencePage"
},
v7 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "ConfluenceBlogPostLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v5/*: any*/)
    }
  ],
  "type": "ConfluenceBlogPost"
},
v8 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "ConfluenceWhiteboardLinks",
      "kind": "LinkedField",
      "name": "links",
      "plural": false,
      "selections": (v5/*: any*/)
    }
  ],
  "type": "ConfluenceWhiteboard"
},
v9 = [
  {
    "concreteType": "ConfluenceCommentLinks",
    "kind": "LinkedField",
    "name": "links",
    "plural": false,
    "selections": (v5/*: any*/)
  },
  {
    "kind": "LinkedField",
    "name": "container",
    "plural": false,
    "selections": [
      (v0/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/)
    ]
  }
],
v10 = [
  {
    "kind": "ScalarField",
    "name": "url"
  }
],
v11 = {
  "kind": "ScalarField",
  "name": "webUrl"
},
v12 = [
  (v11/*: any*/)
],
v13 = [
  (v11/*: any*/),
  {
    "concreteType": "JiraIssue",
    "kind": "LinkedField",
    "name": "issue",
    "plural": false,
    "selections": (v12/*: any*/)
  }
],
v14 = [
  {
    "alias": "trelloUrl",
    "kind": "ScalarField",
    "name": "url"
  }
],
v15 = [
  {
    "alias": "webUrl",
    "kind": "ScalarField",
    "name": "url"
  }
],
v16 = [
  {
    "concreteType": "AssetsLinks",
    "kind": "LinkedField",
    "name": "links",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "web"
      }
    ]
  }
],
v17 = {
  "kind": "Variable",
  "name": "orgId",
  "variableName": "orgId"
},
v18 = [
  {
    "kind": "ScalarField",
    "name": "accountIdentifier"
  },
  {
    "kind": "ScalarField",
    "name": "numberOfDirectReports"
  },
  {
    "kind": "ScalarField",
    "name": "numberOfTotalReports"
  },
  {
    "concreteType": "KnowledgeDiscoveryReportingLinesUserPII",
    "kind": "LinkedField",
    "name": "pii",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "concreteType": "KnowledgeDiscoveryReportingLinesUserExtendedProfile",
        "kind": "LinkedField",
        "name": "extendedProfile",
        "plural": false,
        "selections": [
          (v4/*: any*/)
        ]
      }
    ]
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "collabContextId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "orgId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "siteAri"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "skipActivity"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "skipKnowledgeDiscovery"
    },
    {
      "defaultValue": true,
      "kind": "LocalArgument",
      "name": "skipReportingLines"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "userAri"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "userId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "userIdString"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "viewerId"
    }
  ],
  "kind": "Fragment",
  "name": "UserProfileCardRelay_query",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "accountId",
          "variableName": "userId"
        }
      ],
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "name": "accountId"
        },
        {
          "kind": "ScalarField",
          "name": "accountStatus"
        },
        (v1/*: any*/),
        (v2/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v3/*: any*/),
            {
              "concreteType": "AtlassianAccountUserExtendedProfile",
              "kind": "LinkedField",
              "name": "extendedProfile",
              "plural": false,
              "selections": [
                (v4/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "department"
                },
                {
                  "kind": "ScalarField",
                  "name": "location"
                },
                {
                  "kind": "ScalarField",
                  "name": "organization"
                }
              ]
            }
          ],
          "type": "AtlassianAccountUser"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v3/*: any*/)
          ],
          "type": "CustomerUser"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "appType"
            }
          ],
          "type": "AppUser"
        }
      ]
    },
    {
      "condition": "skipActivity",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "concreteType": "Activity",
          "kind": "LinkedField",
          "name": "activity",
          "plural": false,
          "selections": [
            {
              "args": [
                {
                  "fields": [
                    {
                      "items": [
                        {
                          "kind": "Variable",
                          "name": "actors.0",
                          "variableName": "userAri"
                        }
                      ],
                      "kind": "ListValue",
                      "name": "actors"
                    },
                    {
                      "kind": "Variable",
                      "name": "collabContextId",
                      "variableName": "collabContextId"
                    }
                  ],
                  "kind": "ObjectValue",
                  "name": "filter"
                },
                {
                  "kind": "Literal",
                  "name": "first",
                  "value": 50
                }
              ],
              "concreteType": "ActivityConnection",
              "kind": "LinkedField",
              "name": "workedOn",
              "plural": false,
              "selections": [
                {
                  "concreteType": "ActivityItemEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "concreteType": "ActivityNode",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        {
                          "concreteType": "ActivityObject",
                          "kind": "LinkedField",
                          "name": "object",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "LinkedField",
                              "name": "data",
                              "plural": false,
                              "selections": [
                                (v0/*: any*/),
                                (v6/*: any*/),
                                (v7/*: any*/),
                                (v8/*: any*/),
                                {
                                  "kind": "InlineFragment",
                                  "selections": [
                                    {
                                      "concreteType": "ConfluenceDatabaseLinks",
                                      "kind": "LinkedField",
                                      "name": "links",
                                      "plural": false,
                                      "selections": (v5/*: any*/)
                                    }
                                  ],
                                  "type": "ConfluenceDatabase"
                                },
                                {
                                  "kind": "InlineFragment",
                                  "selections": [
                                    {
                                      "concreteType": "ConfluenceEmbedLinks",
                                      "kind": "LinkedField",
                                      "name": "links",
                                      "plural": false,
                                      "selections": (v5/*: any*/)
                                    }
                                  ],
                                  "type": "ConfluenceEmbed"
                                },
                                {
                                  "kind": "InlineFragment",
                                  "selections": (v9/*: any*/),
                                  "type": "ConfluenceFooterComment"
                                },
                                {
                                  "kind": "InlineFragment",
                                  "selections": (v9/*: any*/),
                                  "type": "ConfluenceInlineComment"
                                },
                                {
                                  "kind": "InlineFragment",
                                  "selections": (v10/*: any*/),
                                  "type": "TownsquareGoal"
                                },
                                {
                                  "kind": "InlineFragment",
                                  "selections": (v10/*: any*/),
                                  "type": "TownsquareProject"
                                },
                                {
                                  "kind": "InlineFragment",
                                  "selections": (v10/*: any*/),
                                  "type": "TownsquareComment"
                                },
                                {
                                  "kind": "InlineFragment",
                                  "selections": (v12/*: any*/),
                                  "type": "JiraIssue"
                                },
                                {
                                  "kind": "InlineFragment",
                                  "selections": (v13/*: any*/),
                                  "type": "JiraPlatformComment"
                                },
                                {
                                  "kind": "InlineFragment",
                                  "selections": (v13/*: any*/),
                                  "type": "JiraServiceManagementComment"
                                },
                                {
                                  "kind": "InlineFragment",
                                  "selections": (v14/*: any*/),
                                  "type": "TrelloBoard"
                                },
                                {
                                  "kind": "InlineFragment",
                                  "selections": (v14/*: any*/),
                                  "type": "TrelloCard"
                                },
                                {
                                  "kind": "InlineFragment",
                                  "selections": (v15/*: any*/),
                                  "type": "DevOpsDocument"
                                },
                                {
                                  "kind": "InlineFragment",
                                  "selections": (v10/*: any*/),
                                  "type": "ExternalDocument"
                                },
                                {
                                  "kind": "InlineFragment",
                                  "selections": (v10/*: any*/),
                                  "type": "DevOpsPullRequestDetails"
                                },
                                {
                                  "kind": "InlineFragment",
                                  "selections": (v10/*: any*/),
                                  "type": "ExternalPullRequest"
                                },
                                {
                                  "kind": "InlineFragment",
                                  "selections": (v15/*: any*/),
                                  "type": "DevOpsDesign"
                                },
                                {
                                  "kind": "InlineFragment",
                                  "selections": (v10/*: any*/),
                                  "type": "ExternalRemoteLink"
                                },
                                {
                                  "kind": "InlineFragment",
                                  "selections": (v10/*: any*/),
                                  "type": "MercuryFocusArea"
                                },
                                {
                                  "kind": "InlineFragment",
                                  "selections": (v10/*: any*/),
                                  "type": "MercuryPortfolio"
                                },
                                {
                                  "kind": "InlineFragment",
                                  "selections": (v10/*: any*/),
                                  "type": "RadarPosition"
                                },
                                {
                                  "kind": "InlineFragment",
                                  "selections": (v10/*: any*/),
                                  "type": "RadarView"
                                },
                                {
                                  "kind": "InlineFragment",
                                  "selections": (v10/*: any*/),
                                  "type": "CompassComponent"
                                },
                                {
                                  "kind": "InlineFragment",
                                  "selections": [
                                    {
                                      "kind": "ScalarField",
                                      "name": "href"
                                    }
                                  ],
                                  "type": "BitbucketPullRequest"
                                },
                                {
                                  "kind": "InlineFragment",
                                  "selections": [
                                    {
                                      "alias": "loomUrl",
                                      "kind": "ScalarField",
                                      "name": "url"
                                    }
                                  ],
                                  "type": "LoomVideo"
                                },
                                {
                                  "kind": "InlineFragment",
                                  "selections": (v16/*: any*/),
                                  "type": "AssetsObject"
                                },
                                {
                                  "kind": "InlineFragment",
                                  "selections": (v16/*: any*/),
                                  "type": "AssetsObjectType"
                                },
                                {
                                  "kind": "InlineFragment",
                                  "selections": (v16/*: any*/),
                                  "type": "AssetsSchema"
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "condition": "skipKnowledgeDiscovery",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "concreteType": "KnowledgeDiscoveryQueryApi",
          "kind": "LinkedField",
          "name": "knowledgeDiscovery",
          "plural": false,
          "selections": [
            {
              "args": [
                {
                  "kind": "Variable",
                  "name": "accountId",
                  "variableName": "userIdString"
                },
                (v17/*: any*/),
                {
                  "kind": "Variable",
                  "name": "requestingUserId",
                  "variableName": "viewerId"
                },
                {
                  "kind": "Variable",
                  "name": "tenantId",
                  "variableName": "cloudId"
                }
              ],
              "kind": "LinkedField",
              "name": "singleUser",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "concreteType": "KnowledgeDiscoveryUserProfile",
                      "kind": "LinkedField",
                      "name": "user",
                      "plural": false,
                      "selections": [
                        {
                          "concreteType": "KnowledgeDiscoveryUserManager",
                          "kind": "LinkedField",
                          "name": "manager",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "ScalarField",
                              "name": "id"
                            },
                            (v4/*: any*/),
                            (v2/*: any*/),
                            (v1/*: any*/)
                          ]
                        },
                        {
                          "concreteType": "KnowledgeDiscoveryThirdPartyIntegration",
                          "kind": "LinkedField",
                          "name": "thirdPartyIntegrations",
                          "plural": true,
                          "selections": [
                            {
                              "kind": "ScalarField",
                              "name": "externalId"
                            },
                            {
                              "kind": "ScalarField",
                              "name": "integrationId"
                            },
                            {
                              "kind": "ScalarField",
                              "name": "product"
                            }
                          ]
                        }
                      ]
                    }
                  ],
                  "type": "KnowledgeDiscoverySingleUser"
                }
              ]
            },
            {
              "condition": "skipReportingLines",
              "kind": "Condition",
              "passingValue": false,
              "selections": [
                {
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "aaid",
                      "variableName": "userIdString"
                    },
                    (v17/*: any*/),
                    {
                      "kind": "Variable",
                      "name": "siteId",
                      "variableName": "siteAri"
                    }
                  ],
                  "kind": "LinkedField",
                  "name": "reportingLines",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                          "kind": "LinkedField",
                          "name": "user",
                          "plural": false,
                          "selections": (v18/*: any*/)
                        },
                        {
                          "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                          "kind": "LinkedField",
                          "name": "managers",
                          "plural": true,
                          "selections": (v18/*: any*/)
                        },
                        {
                          "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                          "kind": "LinkedField",
                          "name": "reports",
                          "plural": true,
                          "selections": (v18/*: any*/)
                        }
                      ],
                      "type": "KnowledgeDiscoveryReportingLines"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "e4a2f1bfd51bb9f71c5016c4ec581b94";

export default node;
